var _defs, _path, _g, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStandardLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "TS_Brandmark",
    "data-name": "TS Brandmark",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 168.44 108.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #004ea8;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m154.5,68.03c-5.5-21.8-7.3-33.5-13.5-41.1-3.3-4.1-13.8-17.9-58.1-11.3C54.4,19.83,75-1.87,44.4.13,23.9,1.43,0,9.03,0,9.03c0,0,8.7,4.4,14.7,38.4,6.5,36.7,1.3,52.6,1.3,52.6,7.2-2.6,20.1-6.3,37-7,30.7-1.2-.6,22.1,27.2,14.4,66.4-18.5,87.5-.5,88.2-1.4.6-.9-5.3-4.1-13.9-38Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m84.8,53.93v9.7h-2.2v-1.6c-1.3,1.3-2.5,1.8-4.5,1.8-2.4,0-4.4-1.1-4.4-3.6,0-3,2.3-3.7,4.5-4.1,2.4-.4,4.4-.3,4.4-1.9,0-1.9-1.5-2.2-2.9-2.2-1.8,0-3.2.6-3.3,2.5h-2.2c.1-3.3,2.7-4.4,5.6-4.4,2.3,0,4.9.8,5,3.8Zm-2.2,2.9c-.8.6-2.4.6-3.9.9s-2.7.8-2.7,2.4c0,1.2,1.3,1.9,2.6,1.9,2.8,0,4-1.7,4-3v-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m70,46.53h-2.2v3.9h-2.3v1.9h2.3v8.5c0,2.5,1.7,2.9,3.1,2.9s1.7-.1,1.7-.1v-1.9h-1c-1.4,0-1.7-.3-1.7-1.4v-8h2.7v-1.9h-2.7v-3.9h.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "21.1 50.43 25.6 50.43 25.6 63.53 26.9 63.53 26.9 50.43 31.4 50.43 31.4 49.33 21.1 49.33 21.1 50.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m50.1,58.63h-7.9c0,1.8,1,4,3.4,4,1.8,0,2.8-1,3.2-2.6h1.3c-.6,2.3-1.9,3.7-4.5,3.7-3.2,0-4.6-2.5-4.6-5.4,0-2.7,1.3-5.4,4.6-5.4s4.6,2.9,4.5,5.7Zm-7.8-.9h6.6c-.1-1.9-1.3-3.7-3.3-3.7s-3.2,1.8-3.3,3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m59.7,53.33c-2.9-.7-5.8-1-5.8-3.2,0-2.4,2-3.1,4.1-3.1,2.4,0,4.1,1,4.5,3.5h2.3c-.3-3.8-3-5.5-6.7-5.5-3.3,0-6.6,1.6-6.6,5.3,0,3.3,2.9,4.2,5.8,4.8,2.9.6,5.8,1.1,5.8,3.6s-2.4,3.3-4.6,3.3c-2.8,0-4.8-1.3-5.2-3.4h-2.3c.5,3.5,3.4,5.5,7.5,5.5,3.3,0,7.1-1.6,7.1-5.4-.1-3.7-3-4.7-5.9-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m36.5,52.93c-1.4,0-2.8.8-3.3,2.1h0v-5.7h-1.3v14.2h1.3v-6c0-2,1.2-3.5,3.2-3.5s2.6,1.3,2.6,3.1v6.4h1.3v-6.6c0-2.5-.9-4-3.8-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m131.8,50.23c-2.3-.2-3.8.6-4.8,2.7h-.1v-2.4h-2v13.2h2.2v-6.1c0-3.3,1.3-5.2,4.8-5.2v-2.2h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m142,52.23v-6.8h2.2v18.3h-2.2v-1.8h-.1c-.8,1.4-2.4,2-4.2,2-4,0-6.1-3.2-6.1-6.9s2-6.9,6-6.9c1.3,0,3.3.5,4.3,2.1h.1Zm.1,4.9c0-2.6-1.2-5-4.2-5s-4,2.5-4,5.1,1.3,4.8,4.1,4.8,4-2.5,4.1-4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m92.7,50.13c-1.9,0-3.4.8-4.3,2.4h-.1v-2.1h-2v13.2h2.2v-7.4c0-2.4,1.3-4.1,3.9-4.1,1.7,0,2.7,1,2.7,2.7v8.9h2.2v-8.7c0-2.9-1.1-4.9-4.6-4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m108.9,52.23v-6.8h2.2v18.3h-2.2v-1.8h-.1c-.8,1.4-2.4,2-4.2,2-4,0-6.1-3.2-6.1-6.9s2-6.9,6-6.9c1.3,0,3.3.5,4.3,2.1h.1Zm.1,4.9c0-2.6-1.2-5-4.2-5s-4,2.5-4,5.1,1.3,4.8,4.1,4.8,3.9-2.5,4.1-4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m123.3,53.93v9.7h-2.2v-1.6c-1.3,1.3-2.5,1.8-4.5,1.8-2.4,0-4.4-1.1-4.4-3.6,0-3,2.3-3.7,4.5-4.1,2.4-.4,4.4-.3,4.4-1.9,0-1.9-1.5-2.2-2.9-2.2-1.8,0-3.2.6-3.3,2.5h-2.2c.1-3.3,2.7-4.4,5.6-4.4,2.4,0,4.9.8,5,3.8Zm-2.2,2.9c-.8.6-2.4.6-3.9.9s-2.7.8-2.7,2.4c0,1.2,1.3,1.9,2.6,1.9,2.8,0,4-1.7,4-3v-2.2Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m159,48.93c0,2.1-1.6,3.5-3.4,3.5-2,0-3.5-1.5-3.5-3.5,0-2.1,1.6-3.5,3.5-3.5,1.8,0,3.4,1.4,3.4,3.5Zm-.8,0c0-1.7-1.2-2.9-2.7-2.9s-2.7,1.2-2.7,2.9c0,1.6,1,2.9,2.7,2.9,1.5,0,2.7-1.2,2.7-2.9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m156.1,49.23l1.1,1.7h-.7l-1-1.7h-.6v1.7h-.6v-3.9h1.5c.9,0,1.4.3,1.4,1.1-.1.7-.6,1-1.1,1.1Zm-.6-.5c.5,0,.9,0,.9-.6,0-.5-.5-.5-.8-.5h-.8v1.1h.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandardLogo);
export default __webpack_public_path__ + "static/media/StandardLogo.a67f2378678eb941d10d050ae90b09db.svg";
export { ForwardRef as ReactComponent };